import React, { useEffect } from "react";
import "./Advantage5.css";
import num5dark from "../images/num5-dark.png";

const Advantage5 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = document.querySelectorAll(".advantage5-1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="advantage5-1">
      <div className="advantage5-2">
        <div className="img5-1 animate-side slide-left">
          <div
            className="logo-light"
            style={{
              backgroundImage: `url(${num5dark})`,
            }}
          />
        </div>
        <div className="advantage5-content animate-side slide-right">
          <h1>Lower Cost of Ownership & Scalability</h1>
          <div className="advantage5-3">
            <p>
              <label>Minimal Upfront Capital:</label>
              Avoid expensive on-premise servers and high license fees with cost-efficient, cloud-native deployments.<br/>
              <label>Flexible Scaling:</label>
              Easily expand your setup as you grow—add new store locations, registers, or digital menu terminals in minutes.<br/>
              <label>Reduced IT Overhead:</label>
              We manage software updates, cloud infrastructure, and system maintenance so you can focus entirely on your core business.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantage5;